module.exports = __webpack_public_path__ + "static/media/maisAP.4d9ebd47.svg";